

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"id":"svg-paperClip-wXmtQoL","d":"M18.2083 6.67739V17.1667C18.2083 20.0432 15.8765 22.3751 13 22.3751C10.1235 22.3751 7.79167 20.0432 7.79167 17.1667V7.09728C7.79167 5.17963 9.34624 3.62506 11.2639 3.62506C13.1815 3.62506 14.7361 5.17963 14.7361 7.09728V17.1506C14.7361 18.1094 13.9588 18.8867 13 18.8867C12.0412 18.8867 11.2639 18.1094 11.2639 17.1506V7.27089","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n"]);
};

        